import React from 'react';
import '../../App.css';
import '../Menu.css'; 

function Menu() {
  const pdfUrl = process.env.PUBLIC_URL + '/finismenu.pdf';

  return (
    <div className="subpage-container">
      <h1>MENU</h1>
      
      {/* This shows on Desktop */}
      <iframe 
        className="pdf-viewer"
        src={`${pdfUrl}#view=FitH`} 
        title="Finis Menu"
      ></iframe>

      {/* This shows on Mobile (via CSS display: none) */}
      <a href={pdfUrl} target="_blank" rel="noreferrer" className="mobile-menu-trigger">
        <i className="fas fa-file-pdf"></i>
        <span>OTVORIŤ JEDÁLNY LÍSTOK</span>
        <small>(Kliknite pre zobrazenie)</small>
      </a>

      <a href={pdfUrl} download className="download-link">
        <i className="fas fa-download"></i> STIAHNUŤ PDF
      </a>
    </div>
  );
}

export default Menu;